<template>
  <div>
    <div class="rpg-pd-5">
      <div class="rpg-pd-5-10 rpg-bd-b rpg-pr-title">
        <span class="rpg-label">{{ project.客户公司 }}-{{ project.项目名称 }}</span>
        <span class="rpg-gray">（当前项目）</span>
      </div>
      <div class="rpg-pd-5-10 rpg-label">
        安排面试 <peixun type="8" style="display:inline-block;margin-left:5px;position:relative;top:3px;"></peixun>
      </div>
      <el-form ref="form" :model="form" label-width="100px" size="mini">
        <el-form-item label="候选人:"> {{ form['候选人'] }} </el-form-item>
        <el-form-item label="推荐顾问:"> {{ form['顾问'] }} </el-form-item>
        <el-form-item label="面试时间:">
          <el-date-picker
            v-model="form['面试时间']"
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            placeholder="选择日期时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="面试官:">
          <div style="display: flex;flex-wrap: wrap;align-items: center;">
            <template v-if="!guanLoading">
              <el-tag
                v-for="(item, k) in form.面试官们"
                :key="k"
                effect="dark"
                :type="item._id ? '' : 'info'"
                closable
                size="small"
                @close="handleDelGuan(item)"
                style="margin:3px"
              >
                {{ item.姓名 }}
              </el-tag>
            </template>
            <el-autocomplete
              v-model="tmpKeyword"
              :fetch-suggestions="querySearchAsync"
              placeholder="输入后选择或回车"
              :trigger-on-focus="false"
              @select="handleSelectGuan"
              @keyup.enter.native="handleInputGuan"
              popper-class="companyhr-item"
              style="width:187px"
            >
              <template slot-scope="{ item }">
                <div v-if="item.姓名 === '没找到，新建一个人'" class="hr-add-btn">
                  <button type="button" class="el-button ml-20 el-button--text el-button--small">
                    <span>+ 没找到，新建一个人</span>
                  </button>
                </div>
                <div v-else>
                  <div class="name">{{ item.姓名 }}</div>
                  <span class="addr">{{ item.部门 }} {{ item.目前职位 }}</span>
                </div>
              </template>
            </el-autocomplete>
          </div>
          <div style="font-size:12px;color:#aaa;line-height:1.2;margin-top:5px">
            1、输入面试官名称并选择下拉列表中系统已有的人选，可以添加到关键面试人。<br />2、输入面试官情况并回车直接添加文字
          </div>
        </el-form-item>
        <el-form-item label="面试联系人:">
          <el-autocomplete
            v-model="form['联系人']"
            :fetch-suggestions="fetchSuggestionsHr"
            placeholder="输入姓名或选择公司hr"
            @select="selectHr"
          ></el-autocomplete>
        </el-form-item>
        <el-form-item label="联系电话:">
          <el-input v-model="form['联系电话']" placeholder="输入hr联系方式"></el-input>
        </el-form-item>
        <el-form-item label="面试地址:">
          <el-autocomplete
            v-model="form['面试地址']"
            size="mini"
            placeholder="面试地址"
            :fetch-suggestions="fetchSuggestions"
          ></el-autocomplete>
        </el-form-item>
        <el-form-item label="面试方式:">
          <el-radio-group v-model="form['面试方式']" size="small">
            <el-radio-button v-for="(interType, k) in interTypes" :key="k" :label="interType" border>{{
              interType
            }}</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="终面:">
          <el-switch v-model="form.isFinal" class="rpg-mgr-5"></el-switch>
          <!-- <span class="rpg-yellow">终面之后人选会进入谈offer阶段</span> -->
        </el-form-item>
        <el-form-item label="备注:">
          <el-input type="textarea" v-model="form['备注']" placeholder="特殊说明可填写备注"></el-input>
          <el-checkbox v-model="form.sendWx">发送微信消息通知客户&项目经理</el-checkbox>
        </el-form-item>
      </el-form>
      <div class="rpg-dialog-item rpg-text-center">
        <el-button size="mini" type="primary" @click="handleConfirm">提交</el-button>
      </div>
    </div>
    <el-dialog title="提示" :visible.sync="keyRadishVisible" width="300px" :append-to-body="true" :modal="false">
      <div style="font-size:12px;color:#aaa;line-height:1.2;margin-bottom:5px">
        请选择要同步哪位面试官到关键面试决策人
      </div>
      <div><el-checkbox v-model="checkAll" @change="toogleGuan">全选</el-checkbox></div>
      <div v-if="!guanLoading">
        <template v-for="(item, k) in form.面试官们">
          <el-checkbox v-if="item._id" :key="k" v-model="item.toKeyRadish" @change="reloadGuan">{{
            item.姓名
          }}</el-checkbox>
        </template>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="close">取消</el-button>
        <el-button size="mini" type="primary" @click="confirmToKeyRadish('some')">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
const dateFormat = require('dateformat')
export default {
  props: {
    radish: {
      type: Object,
    },
    project: {
      type: Object,
    },
    onConfirm: {
      type: Function,
      default: function() {},
    },
  },
  data: function() {
    return {
      form: {},
      addr: [],
      hr: [],
      comId: '',
      submiting: false,
      rid: '',
      pid: '',
      interTypes: ['现场面试', '视频面试', '电话面试'],
      guanLoading: false,
      guanOptions: [],
      tmpKeyword: '',
      keyRadishVisible: false,
      checkAll: false,
    }
  },
  async mounted() {
    console.log('m')
    this.rid = this.radish.rid || this.radish._id
    this.pid = this.project._id
    this.initForm()
    if (this.project['客户公司']) {
      const com = await app.service('company').getCompany(this.project['客户公司'])
      if (com.status == 200) {
        this.comId = com.result._id
        if (com.result['面试地址']) {
          this.addr = com.result['面试地址'] || []
        }
        if (com.result['对接hr']) {
          this.hr = com.result['对接hr'] || []
        }
      }
    }
  },
  methods: {
    async initForm() {
      let form = {
        isFinal: false,
        sendWx: true,
        面试时间: '',
        面试官们: [],
        联系人: '',
        联系电话: '',
        面试地址: '',
        面试方式: '',
        备注: '',
      }
      form['候选人'] = this.radish['姓名']
      form.rid = this.rid
      form.pid = this.pid
      const res = await app.service('radish').findRecommend({ rid: this.rid, pid: this.pid })
      if (res.status == 'success') {
        if (res.data.length > 0) {
          form['顾问'] = res.data[0].顾问
          await this.initRoundOne()
        } else {
          this.$message.error('未找到对应推荐数据')
        }
      }
      this.form = form
    },
    async initRoundOne() {
      const intRes = await app.service('radish').findInterview({ rid: this.rid, pid: this.pid })
      if (intRes.status === 'success' && intRes.data.length > 0) {
        if (intRes.data[0].联系人) this.form.联系人 = intRes.data[0].联系人
        if (intRes.data[0].联系电话) this.form.联系电话 = intRes.data[0].联系电话
        if (intRes.data[0].面试地址) this.form.面试地址 = intRes.data[0].面试地址
      }
    },
    fetchSuggestions: function(qs, cb) {
      if (this.addr.length > 0) {
        let s = this.addr.map(item => {
          return { value: item['地址'] }
        })
        if (!qs) {
          cb(s)
        } else {
          cb(
            s.filter(c => {
              return c.value && c.value.toUpperCase().indexOf(qs.toUpperCase()) != -1
            }),
          )
        }
      } else {
        cb([])
      }
    },
    fetchSuggestionsHr: function(qs, cb) {
      if (this.hr.length > 0) {
        let s = this.hr.map(item => {
          return { value: item['姓名'] }
        })
        if (!qs) {
          cb(s)
        } else {
          cb(
            s.filter(c => {
              return c.value && c.value.toUpperCase().indexOf(qs.toUpperCase()) != -1
            }),
          )
        }
      } else {
        cb([])
      }
    },
    selectHr() {
      if (this.form['联系人'] && this.hr.length > 0) {
        const hrObj = this.hr.find(h => h.姓名 == this.form['联系人'])
        if (hrObj && hrObj.手机) {
          this.form.联系电话 = hrObj.手机
        }
      }
    },
    async addCommunicate(text) {
      const answer = {
        remark: [
          {
            stem: '沟通记录',
            answer: text,
            time: Date.now(),
            user: app.user.提供者 || app.user.account,
          },
        ],
        radishId: this.rid,
      }
      const res = await app.service('communication').upsert(answer)
    },
    handleConfirm: async function() {
      // return console.log(this.form)
      if (this.submiting) return this.$message('提交中，请勿重复提交')
      this.submiting = true
      this.handleInputGuan()
      const dt = JSON.parse(JSON.stringify(this.form))
      dt['面试时间'] = dateFormat(dt['面试时间'], 'yyyy-mm-dd HH:MM')
      const res = await app.service('radish').addInterview(dt)
      if (res.status == 'success') {
        const address = this.addr.map(val => val.地址)
        const newAddr = dt['面试地址'] || ''
        const bannedKeyWords = ['微信', '电话']
        const hasKeyWords = bannedKeyWords.some(val => newAddr.includes(val))
        if (this.comId && newAddr && !hasKeyWords && !address.includes(newAddr)) {
          const newAddress = { cid: this.comId, 地址: dt['面试地址'], 备注: '' }
          const res = await app.service('company').addCompanyAddress(newAddress)
          if (res.status === 'success') this.addr = res.data
        }
      }
      if (res.msg == '已经淘汰') {
        this.$confirm('候选人已经被淘汰不能面试，是否要重启面试?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            await this.uneliminate()
            this.submiting = false
            this.handleConfirm()
          })
          .catch(() => {
            this.submiting = false
          })
      } else {
        if (res.status == 'success') {
          // 添加日历
          const canyu = [this.form.顾问]
          if (this.project.客户开发) {
            if (Array.isArray(this.project.客户开发) && this.project.客户开发.length > 0) {
              canyu.push(this.project.客户开发[0])
            } else {
              canyu.push(this.project.客户开发)
            }
          }
          const desc = `候选人：${dt.候选人 || ''}；职位：${this.project.客户公司 }-${ this.project.项目名称}${dt.面试地址?'；面试地址：'+dt.面试地址:''}${dt.面试官?'；面试官：'+dt.面试官:''}${dt.备注?'；备注：'+dt.备注:''}`
          await app.service('misc').addRili({
            类型: '面试',
            时间: dt.面试时间 ? new Date(dt.面试时间).getTime() : new Date().getTime(),
            备注: desc,
            参与人: canyu,
            关联人选: this.radish.姓名,
            rid: this.radish._id,
            关联项目: this.project.项目名称,
            pid: this.project._id,
            interviewId: res.data.id
          })
          // 关键决策人
          if (this.form.面试官们 && this.form.面试官们.length > 0 && this.form.面试官们.find(m => m._id)) {
            this.keyRadishVisible = true
          } else {
            if (this.form.isFinal && this.form.候选人 && this.project.客户公司) {
              this.addCommunicate(`${this.form.候选人}已经被安排参加${this.project.客户公司}终面`)
            }
            this.onConfirm()
            this.initForm()
          }
          this.$message.success(res.msg)
        } else {
          this.$message.info(res.msg)
        }
        this.submiting = false
      }
    },
    async confirmToKeyRadish(type) {
      let guan =
        type == 'all'
          ? this.form.面试官们.filter(m => m._id).map(m => m._id)
          : this.form.面试官们.filter(m => m.toKeyRadish).map(m => m._id)
      if (guan.length > 0) {
        let mian = []
        if (!this.project['关键面试人']) {
          mian = guan
        } else {
          mian = Array.from(new Set(this.project['关键面试人'].concat(guan)))
        }
        await app.service('project').modify({
          id: this.project._id,
          param: { 关键面试人: mian },
        })
        await app.service('radish').updateInterview({ _id: this.form._id, data: { 面试官们: this.form.面试官们 } })
      }
      this.close()
    },
    uneliminate: async function() {
      const intRes = await app.service('radish').findInterview({ rid: this.rid, pid: this.pid })
      if (intRes.status === 'success') {
        const intvs = intRes.data.filter(i => i['结果'] === '淘汰')
        if (intvs.length > 0) {
          await app.service('radish').modifyInterview({ _id: intvs[0]._id, data: { 结果: '重启' } })
          this.$message.success('重启成功')
        }
      }
    },
    async querySearchAsync(keyword, cb) {
      const query = { 公司: this.project['客户公司'] }
      let results = []
      if (keyword) {
        query.姓名 = { $regex: keyword, $options: 'i' }
        if (keyword.length == 1) {
          query.职级 = { $in: [1, 2, 3, '1', '2', '3'] }
        }
      } else {
        query.职级 = { $in: [1, 2, 3, '1', '2', '3'] }
      }
      const res = await app.service('radish').simpleList({
        query,
        fields: { 姓名: 1, 部门: 1, 目前职位: 1 },
      })
      if (res.status === 'success') {
        results = res.data
      }
      results.push({ 姓名: '没找到，新建一个人' })
      cb(results)
    },
    async handleSelectGuan(item) {
      if (item.姓名 == '没找到，新建一个人') {
        return this.gotoAddRadish()
      }
      if (
        item._id &&
        this.form.面试官们 &&
        this.form.面试官们.length > 0 &&
        this.form.面试官们.find(a => a._id == item._id)
      ) {
        return this.$message('已选择过该面试官')
      }
      if (!this.form.面试官们) this.form.面试官们 = []
      this.form.面试官们.push(item)
      this.$set(this.form, '面试官', this.form.面试官们.map(a => a.姓名).join(';'))
      this.tmpKeyword = ''
    },
    handleInputGuan() {
      if (this.tmpKeyword) {
        this.handleSelectGuan({ 姓名: this.tmpKeyword })
      }
    },
    handleDelGuan(item) {
      this.guanLoading = true
      if (item._id) {
        this.$set(this.form, '面试官们', this.form.面试官们.filter(a => a._id != item._id))
      } else {
        this.$set(this.form, '面试官们', this.form.面试官们.filter(a => a._id || a.姓名 != item.姓名))
      }
      this.$set(this.form, '面试官', this.form.面试官们.map(a => a.姓名).join(';'))
      this.guanLoading = false
    },
    gotoAddRadish() {
      // this.$refs.guanSelect.$el.click()
      app.root.$refs.radishAdd.open({ 姓名: this.tmpKeyword, 公司: this.project.客户公司 })
    },
    toogleGuan() {
      this.guanLoading = true
      this.$set(
        this.form,
        '面试官们',
        this.form.面试官们.map(a => {
          a.toKeyRadish = this.checkAll
          return a
        }),
      )
      this.guanLoading = false
    },
    close() {
      this.keyRadishVisible = false
      this.onConfirm()
      this.initForm()
    },
    reloadGuan() {
      this.guanLoading = true
      this.$nextTick(() => {
        this.guanLoading = false
      })
    },
  },
}
</script>
<style scoped>
.companyhr-item li .name {
  line-height: normal;
  text-overflow: ellipsis;
  overflow: hidden;
}
.companyhr-item li .addr {
  line-height: normal;
  font-size: 12px;
  color: #b4b4b4;
}
</style>
